<template>
    <div>
        <div class="head">
            <el-button type="primary" size="small" style="width: 80px" @click="addBtn">新增</el-button>
        </div>
        <div class="content">
            <el-table
                    :data="safechartList"
                    :header-cell-style="{ background: 'rgb(250,250,250)' }"
                    style="width: 100%">
                <el-table-column label="四色风险分布图名称" align="center" prop="enterpriseName" width="400"/>
                <el-table-column label="创建人" align="center" prop="creator"/>
                <el-table-column label="操作" width="120">
                    <template slot-scope="{ row }">
                        <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
                        <span style="margin: 0 5px;color: #e8e8e8">|</span>
                        <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: right; margin-top: 15px">
                <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
            </div>
        </div>

        <!-- 添加或修改风险四色图管理对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="140px">
                <el-form-item label="四色风险分布图名称" prop="enterpriseName">
                    <el-input v-model="form.enterpriseName" placeholder="请输入四色风险分布图名称"/>
                </el-form-item>
<!--                <el-upload
                        class="avatar-uploader"
                        action="/v1/safechart/uploadFile"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess">
                    <img v-if="form.enterpriseName" :src="form.enterpriseName" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>-->
                <el-form-item label="创建人" prop="creator">
                    <el-input v-model="form.creator" placeholder="请输入创建人"/>
                </el-form-item>
                <el-form-item label="数据对接省厅" prop="isTest">
                    <el-select v-model="form.isTest" style="width: 100%">
                        <el-option :value="1" label="否"/>
                        <el-option :value="0" label="是"/>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        listSafechart,
        getSafechart,
        delSafechart,
        addSafechart,
        updateSafechart
    } from '@/api/doublePrevention/safechart'

    export default {
        name: 'ProcessRawMaterials',
        data() {
            return {
                // searchContent: '',
                safechartList: [],
                total: 0,
                curPage: 1,
                pageSize: 10,
                imgurl: null,
                open: false,
                form: {},
                rules: {},
                title: null
            }
        },
        created() {
            this.getSafechartList();
        },
        methods: {
            getSafechartList() {
                listSafechart({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
                    this.safechartList = res.body.data
                    this.total = res.body.cum
                })
            },
            pageChange(val) {
                this.curPage = val;
                this.getSafechartList();
            },
            addBtn() {
                this.reset()
                this.open = true
                this.title = '添加风险四色图管理'

            },
            editBtn(row) {
                console.log(row)
                this.reset()
                const id = row.id
                getSafechart(id).then(response => {
                    this.form = response.body.data
                    this.open = true
                    this.title = '修改风险四色图管理'
                })
            },
            deleteBtn(row) {
                delSafechart(row.id).then(res => {
                    this.$message.success('删除成功')
                    this.getSafechartList()
                })
            },
            // 取消按钮
            cancel() {
                this.open = false
                this.reset()
            },
            // 上传图片
            handleAvatarSuccess(res, file) {
                this.imgurl = res.data
                console.log(this.imgurl)
                //this.$set(this.form, "enterpriseName", res.data);
            },
            // 表单重置
            reset() {
                this.form = {
                    id: null,
                    safechartId: null,
                    enterpriseId: null,
                    enterpriseName: null,
                    companyCode: null,
                    createTime: null,
                    creator: null,
                    recordStatus: null,
                    isTest: null
                }
            },
            /** 提交按钮 */
            submitForm() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        if (this.form.id != null) {
                            updateSafechart(this.form).then(response => {
                                this.open = false
                                this.getSafechartList()
                            })
                        } else {
                            addSafechart(this.form).then(response => {
                                this.open = false
                                this.getSafechartList()
                            })
                        }
                    }
                })
            },
        }
    }
</script>

<style scoped>
     .head {
         display: flex;
         justify-content: space-between;
         width: calc(100% - 280px);
     }
     .btn {
         cursor: pointer;
     }
</style>
